import {
	redirect,
	type LoaderFunctionArgs,
	type MetaFunction,
} from '@remix-run/node'
import { Link } from '@remix-run/react'
import tempLogo from '#app/assets/temp_logo.png'
import { MaxWidthContent } from '#app/components/max-width-content'
import { H1, H3, P } from '#app/components/typography'
import { Button } from '#app/components/ui/button'
import { getUserId } from '#app/utils/auth.server'

export const meta: MetaFunction = () => [{ title: 'CaseQuest' }]

export async function loader({ request }: LoaderFunctionArgs) {
	const user = await getUserId(request)
	if (user) {
		return redirect('/dashboard')
	}
	return null
}

export default function Index() {
	return (
		<MaxWidthContent>
			<main className=" flex min-h-screen flex-col gap-8 p-2 text-center">
				<div className="flex items-center justify-center gap-2">
					<img className="h-8 rounded-full" src={tempLogo} alt="CaseQuest" />
					<H3>CaseQuest</H3>
				</div>
				<div className="flex items-center justify-center py-12">
					<H1>
						Even the sc
						<span className="text-primary">AI</span>
						es.
					</H1>
				</div>
				<div>
					<Button size="lg" asChild>
						<Link to="/signup">Get Started</Link>
					</Button>
				</div>
			</main>
			<footer className="sticky bottom-0">
				<MaxWidthContent>
					<div className="flex items-center justify-between p-2">
						<P>© 2024 Case Quest</P>
					</div>
				</MaxWidthContent>
			</footer>
		</MaxWidthContent>
	)
}
